import { useContext, useEffect, useState } from "react";
import { Dropdown, Accordion } from "react-bootstrap";
import {
  DashboardContext,
  Graphics,
} from "../../../contexts/Dashboard/DashboardContext";
import { TbExternalLink, TbFilter } from "react-icons/tb";
import TooltipConfig from "../../../components/Tooltip";
import New from "./new";
import "./styles.css";

const AddComponent = () => {
  const {
    addComponent,
    componentsAdd,
    dataComponents,
    environment,
    dataComponentsInScreen,
  } = useContext(DashboardContext);
  const [categorys, setCategorys] = useState<string[]>([]);
  const categorysOrder = [
    "Geral",
    "Números do dia",
    "Ocorrências",
    "Saídas e chegadas",
    "Atrasos na saída",
    "ETA",
    "SLA",
    "Devoluções",
    "Coletas",
    "Tempos",
    "Adesão"
  ];
  const [news, setNews] = useState<string[]>([]);
  const [dataComponentsFormatted, setDataComponentFormatted] = useState<
    Graphics[]
  >([]);

  useEffect(() => {
    categoryList(
      dataComponents.filter(function (value: Graphics) {
        return environment.includes(value.enabled);
      })
    );
  }, [dataComponents]);

  function categoryList(list: Graphics[]) {
    setDataComponentFormatted(list);
    list.map((component: Graphics) => {
      if (!categorys.includes(component.category)) {
        categorys.push(component.category);
      }
      if (component.new && !news.includes(component.category)) {
        news.push(component.category);
      }
    });
    setCategorys(
      categorysOrder.filter((element: string) => categorys.includes(element))
    );
    setNews(news);
  }

  return (
    <Dropdown>
      <Dropdown.Toggle
        variant="info"
        id="dropdown-basic"
      >
        Adicionar
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Accordion>
          {categorys.map((category: string, index: number) => (
            <Accordion.Item eventKey={index.toString()} key={index.toString()}>
              <Accordion.Header>
                <div className="w-100">{category}</div>{" "}
                {news.includes(category) ? <New type="menu" /> : ""}
              </Accordion.Header>
              {dataComponentsFormatted.map((component: Graphics) =>
                component.category === category &&
                !componentsAdd.find(
                  (componentAdd: { id: string }) =>
                    componentAdd.id === component.id
                ) &&
                !dataComponentsInScreen.includes(component.id) ? (
                  <Accordion.Body>
                    <Dropdown.Item
                      id={"componentAdd" + component.id}
                      key={"componentAddKey" + component.id}
                      onClick={() =>
                        addComponent({ id: component.id, dataSaved: null })
                      }
                    >
                      <div className="display-inline-flex">
                        <div className="menu-icons">
                          <TooltipConfig
                            content={[component.iconChart.title]}
                            children={component.iconChart.icon}
                            style={false}
                          />
                        </div>
                        {component.name}
                        {component.new ? <New type="item" /> : ""}
                      </div>
                      <div className="menu-icons">
                        <TooltipConfig
                          content={
                            component.filter ? ["Filtros aplicáveis"] : [""]
                          }
                          children={component.filter ? <TbFilter /> : ""}
                          style={false}
                        />
                        <TooltipConfig
                          content={
                            component.redirect ? ["redirecionável"] : [""]
                          }
                          children={
                            component.redirect ? <TbExternalLink /> : ""
                          }
                          style={false}
                        />
                      </div>
                    </Dropdown.Item>
                  </Accordion.Body>
                ) : (
                  <div key={"componentAddKey" + component.id}></div>
                )
              )}
            </Accordion.Item>
          ))}
        </Accordion>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default AddComponent;
